/**
 * 是否从已安装 Web 应用进入（PWA / 主屏幕 / 桌面快捷方式），与 head/webapp.vue 判定一致。
 * 在模块加载时同步写入 window，供任意脚本读取。
 */
export function isEnteredFromInstalledWebApp() {
  if (navigator.standalone === true) return true
  // 桌面/Android 等：只用 standalone；fullscreen / minimal-ui / window-controls-overlay
  // 在普通 Chrome 标签里可能误匹配，导致误判「从已安装应用进入」
  return window.matchMedia('(display-mode: standalone)').matches
}

export const fromInstalledWebAppFlag = isEnteredFromInstalledWebApp()

if (typeof window !== 'undefined') {
  window.__CG_STORE_FROM_INSTALLED_WEB_APP__ = fromInstalledWebAppFlag
}

import { getAppleDeviceType } from './utils'

/**
 * 任务「桌面应用登录」GO TO：用于预判是否值得等待 beforeinstallprompt。
 * Windows / macOS 的 Chrome；Android 的 Chrome；Android 的 Edge。
 * 不含 iOS、不含 Windows Edge 等。
 * Mac 与 iPad 区分与全站一致：使用 getAppleDeviceType（含 iPadOS 伪装 MacIntel）。
 */
export function isPwaTaskBeforeInstallProbeUa() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  const apple = getAppleDeviceType()
  if (apple === 'iPhone' || apple === 'iPad') return false

  const isAndroid = /Android/i.test(ua)
  const isWin = /Windows NT|Win32|Win64/i.test(ua)
  const isMac = apple === 'Mac'

  const isAndroidEdge = isAndroid && /Edg/i.test(ua)
  if (isAndroidEdge) return true

  const isChromeFamily =
    /Chrome|Chromium/i.test(ua) &&
    !/Edg|OPR|Opera|YaBrowser|SamsungBrowser|UCBrowser|QQBrowser|MiuiBrowser|HuaweiBrowser|wv\)/i.test(
      ua
    )
  if (!isChromeFamily) return false

  if (isAndroid && isChromeFamily) return true
  if ((isWin || isMac) && isChromeFamily) return true

  return false
}
